import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import useFormatMessage from '../../../utils/useFormatMessage';

const ChassisSelectionModal = ({ isOpen, onClose, chassisList, onSelect }) => {

    const { t } = useFormatMessage();
    const [selectedChassis, setSelectedChassis] = useState(null);

    const handleSelect = (chassis) => {
        setSelectedChassis(chassis);
    };

    const handleContinue = () => {
        if (selectedChassis) {
            onSelect(selectedChassis);
            setSelectedChassis(null);
        }
    };

    const handleClose = () => {
        setSelectedChassis(null);
        onClose();
    };

    return (
        <div className="modal-wrapper" style={{ display: isOpen ? 'block' : 'none' }}>
            <Modal isOpen={isOpen} toggle={handleClose} className="chassis-selection-modal">
                <ModalHeader toggle={handleClose}>
                    <div className="d-flex align-items-center">
                        <h5 className="mb-0">{t("Şase Seçimi")}</h5>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div className="chassis-list-container">
                        <div className="chassis-list">
                            {chassisList.map((chassis, index) => (
                                <div
                                    key={index}
                                    className={`chassis-item ${selectedChassis === chassis ? 'selected' : ''}`}
                                    onClick={() => handleSelect(chassis)}
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="chassis-number-container">
                                            <span className="sequence-number" style={{ fontWeight: "700" }}>{index + 1}.</span>
                                            <span className="chassis-number">{chassis}</span>
                                        </div>
                                        <div className="chassis-item-action">
                                            {selectedChassis === chassis ? (
                                                <i className="fa fa-check-circle"></i>
                                            ) : (
                                                <i className="fa fa-chevron-right"></i>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleClose}>
                        <i className="fa fa-times me-2"></i>  &nbsp;
                        {t("İPTAL")}
                    </Button>
                    <Button color="primary" onClick={handleContinue} disabled={!selectedChassis}>
                        {t("DEVAM ET")} &nbsp;
                        <i className="fa fa-arrow-right ms-2"></i>
                    </Button>
                </ModalFooter>
            </Modal>
            <style>
                {`
                    .modal-wrapper {
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        z-index: 1050;
                    }

                    .chassis-selection-modal {
                        display: block !important;
                    }

                    .chassis-list-container {
                        max-height: 60vh;
                        overflow-y: auto;
                    }

                    @media (max-width: 767px) {
                        .chassis-selection-modal {
                            position: fixed;
                            bottom: 0;
                            left: 0;
                            right: 0;
                            margin: 0;
                            top: auto !important;
                            transform: none !important;
                        }

                        .chassis-selection-modal .modal-content {
                            border-radius: 20px 20px 0 0;
                            border: none;
                        }

                        .modal-footer {
                            padding: 1rem;
                            gap: 10px;
                        }

                        .modal-footer .btn {
                            flex: 1;
                            padding: 1rem;
                            font-size: 1.1rem;
                        }
                    }

                    @media (min-width: 768px) {
                        .chassis-selection-modal {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%) !important;
                            width: 100%;
                            max-width: 500px;
                            margin: 0;
                        }
                        
                        .chassis-selection-modal .modal-content {
                            box-shadow: 0 5px 25px rgba(0,0,0,0.1);
                            border: none;
                            border-radius: 16px;
                        }

                        .modal-footer .btn {
                            min-width: 120px;
                            padding: 0.8rem 1.5rem;
                        }
                    }

                    .chassis-number-container {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }

                    .sequence-number {
                        font-size: 1rem;
                        color: #6c757d;
                        min-width: 25px;
                    }

                    .chassis-number {
                        font-size: 1.1rem;
                        font-weight: 500;
                        color: #344767;
                        letter-spacing: 0.3px;
                    }

                    .chassis-item {
                        padding: 1rem;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        border-bottom: 1px solid #f0f0f0;
                    }

                    .chassis-item:hover {
                        background: #f8f9fa;
                    }

                    .chassis-item.selected {
                        background: #f0f7ff;
                    }

                    .chassis-item-action {
                        width: 24px;
                        color: #6c757d;
                        opacity: 0.5;
                        transition: all 0.2s ease;
                        margin-left: 10px;
                    }

                    .chassis-item:hover .chassis-item-action {
                        opacity: 1;
                    }

                    .chassis-item.selected .chassis-item-action {
                        opacity: 1;
                        color: #0d6efd;
                    }

                    .modal-footer {
                        border-top: 1px solid #f0f0f0;
                        padding: 1rem;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                    }

                    .modal-footer .btn {
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 8px;
                        height: 48px;
                    }

                    .modal-footer .btn i {
                        font-size: 1rem;
                    }

                    /* Custom scrollbar */
                    .chassis-list-container::-webkit-scrollbar {
                        width: 6px;
                    }

                    .chassis-list-container::-webkit-scrollbar-track {
                        background: #f1f1f1;
                    }

                    .chassis-list-container::-webkit-scrollbar-thumb {
                        background: #ddd;
                        border-radius: 3px;
                    }

                    .chassis-list-container::-webkit-scrollbar-thumb:hover {
                        background: #ccc;
                    }
                `}
            </style>
        </div>
    );
};

export default ChassisSelectionModal; 